import { Component, Input, OnInit } from '@angular/core';
import { Patient } from '../../models/patient';
import { MaterielDataComponent } from '../materiel-data/materiel-data.component';
import { TuiAppearance, TuiSurface } from '@taiga-ui/core';
import { TuiCardLarge } from '@taiga-ui/layout';
import { Materiel } from '../../models/materiel';

@Component({
  selector: 'app-materiel-list-card',
  standalone: true,
  imports: [
    TuiCardLarge, TuiSurface, TuiAppearance,
    MaterielDataComponent
  ],
  templateUrl: './materiel-list-card.component.html',
  styleUrl: './materiel-list-card.component.scss'
})
export class MaterielListCardComponent implements OnInit {
  @Input() patient: Patient | undefined;
  @Input() activite: string | undefined;

  materielVenduList?: Materiel[];

  ngOnInit(): void {
    this.materielVenduList = this.activite ? this.patient?.tableauDeBord?.materielVenduList?.filter(materiel => materiel.activite === this.activite) : this.patient?.tableauDeBord?.materielVenduList;
    this.materielVenduList = this.materielVenduList ? this.materielVenduList.filter(materiel => materiel.numeroLivraison === this.materielVenduList![0].numeroLivraison) : undefined
  }
}
